import {
  EstateErrorCode,
  EstateIdentity,
  EstateUwReason,
  OperationType,
} from "./estateInterfaces";

import { ErrorState } from "Store/interfaces/products";
import { hasErrorCode } from "Utils/requestUtils";
import { VALID_HOUSE_TYPES } from "./estateConstants";

export const hasNoValidHouseError = (
  estateError: ErrorState<OperationType> | null,
): boolean => hasErrorCode(estateError, EstateErrorCode.NO_VALID_HOUSE);

export const hasUWErrors = (
  estateError: ErrorState<OperationType> | null,
): boolean =>
  Object.values(EstateUwReason).some((v) => hasErrorCode(estateError, v));

export const isValidHouseEstate = (estateIdentity: EstateIdentity): boolean =>
  VALID_HOUSE_TYPES.includes(estateIdentity.simpleHouseType);
